type AdminBranchedCCEmailQuestionProps = {
	question: string;

	note: string;

	goToValue: string;

	onGoToChange: (value: string) => void;
};

const AdminBranchedCCEmailQuestion = ({
	question,
	note,
	goToValue,
	onGoToChange
}: AdminBranchedCCEmailQuestionProps) => {
	return (
		<div className="w-full pt-5 pr-6 pb-8 pl-6 rounded-lg bg-muted flex flex-col gap-6">
			<p className="text-base font-medium text-foreground">CC Email recipient</p>

			<div className="flex flex-col gap-4">
				<p className="text-xl font-medium">{question}</p>
				<p className="text-base font-normal">{note}</p>
			</div>

			<div>
				<div className="flex justify-between items-end mb-2">
					<label className="text-base font-medium">Go to</label>
					<span className="text-xs font-normal">Required</span>
				</div>

				<select
					className="w-full h-10 px-3 bg-white border border-border rounded"
					value={goToValue}
					onChange={(e) => onGoToChange(e.target.value)}
				>
					<option value="NEXT">Next</option>
					<option value="END_OF_FORM">End of the form</option>
				</select>
			</div>
		</div>
	);
};

export default AdminBranchedCCEmailQuestion;
